import { BaseDTO } from '@/request/apiConfig';
import myAxios from '@/request/myAxios';
import { ExternalContactDTO } from '@/dto/contact';

const MAIN_CONTEXT_PATH = import.meta.env.VITE_MAIN_CONTEXT_PATH;

export const apiExternal = {
  external: {
    searchContact: (query: {
      follow_userid: string;
      regex: string;
    }): Promise<BaseDTO<ExternalContactDTO[]>> =>
      myAxios.post(`${MAIN_CONTEXT_PATH}/external/user/search`, query),
  },
};
